import type { ComponentProps, ReactElement } from 'react';

import cx from 'classnames';

export const HouseIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      width="56"
      height="57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 56 57"
      {...props}
    >
      <path d="M54.824 24.154 31.84 1.952c-2.226-2.15-5.85-2.15-8.076 0L.781 24.154a2.517 2.517 0 0 0-.584 2.797 2.605 2.605 0 0 0 2.418 1.59H6.95v23.182c0 2.498 2.072 4.53 4.62 4.53h32.464c2.548 0 4.62-2.032 4.62-4.53V28.541h4.335a2.605 2.605 0 0 0 2.419-1.59 2.517 2.517 0 0 0-.584-2.797ZM33.403 53.589H22.202V37.44c0-1.029.853-1.866 1.903-1.866H31.5c1.05 0 1.904.837 1.904 1.866v16.15Zm13.894-27.71c-.75 0-1.359.595-1.359 1.33v24.514c0 1.03-.854 1.866-1.904 1.866H36.12V37.44c0-2.497-2.073-4.53-4.62-4.53h-7.395c-2.548 0-4.62 2.033-4.62 4.53v16.15H11.57c-1.05 0-1.904-.838-1.904-1.867V27.21c0-.736-.608-1.332-1.358-1.332H2.866L25.67 3.848c1.175-1.134 3.087-1.134 4.262 0l22.806 22.03h-5.442Zm5.692 1.33v-1.33 1.33Z" />
    </svg>
  );
};

export const BusinessIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      width="49"
      height="56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 49 56"
      {...props}
    >
      <path d="M44.23.042H3.792a3.78 3.78 0 0 0-2.68 1.116A3.823 3.823 0 0 0 0 3.854v16.52a5.1 5.1 0 0 0 1.064 3.102A5.053 5.053 0 0 0 3.79 25.28v28.134H0v2.542h48.022v-2.542H44.23V25.28a5.053 5.053 0 0 0 2.727-1.803 5.101 5.101 0 0 0 1.064-3.102V3.854c0-1.011-.4-1.981-1.11-2.696A3.78 3.78 0 0 0 44.23.042Zm1.265 3.812V15.29H40.44V2.583h3.79c.336 0 .657.134.894.372.237.239.37.562.37.899Zm-7.583 16.52c0 .674-.266 1.32-.74 1.797a2.52 2.52 0 0 1-3.575 0 2.548 2.548 0 0 1-.74-1.797v-2.542h5.055v2.542Zm-7.582 0c0 .674-.267 1.32-.74 1.797a2.52 2.52 0 0 1-3.575 0 2.548 2.548 0 0 1-.74-1.797v-2.542h5.055v2.542Zm-7.583 0c0 .674-.266 1.32-.74 1.797a2.52 2.52 0 0 1-3.574 0 2.548 2.548 0 0 1-.74-1.797v-2.542h5.054v2.542Zm-7.582 0c0 .674-.266 1.32-.74 1.797a2.52 2.52 0 0 1-3.575 0 2.548 2.548 0 0 1-.74-1.797v-2.542h5.055v2.542Zm22.747-5.083h-5.055V2.583h5.055v12.708Zm-7.582 0h-5.055V2.583h5.055v12.708Zm-7.583 0h-5.055V2.583h5.055v12.708Zm-7.582 0H10.11V2.583h5.055v12.708ZM2.527 3.854c0-.337.134-.66.37-.899a1.26 1.26 0 0 1 .894-.372h3.791v12.708H2.527V3.854Zm0 16.52v-2.542h5.055v2.542c0 .674-.266 1.32-.74 1.797a2.52 2.52 0 0 1-3.574 0 2.549 2.549 0 0 1-.74-1.797Zm29.066 33.04V40.705h5.055v12.707h-5.055Zm7.583 0v-13.98c0-.336-.133-.66-.37-.898a1.26 1.26 0 0 0-.894-.372H30.33a1.26 1.26 0 0 0-.894.372c-.237.239-.37.562-.37.899v13.978H6.319V25.28a5.114 5.114 0 0 0 2.527-1.576 5.057 5.057 0 0 0 3.791 1.72 5.031 5.031 0 0 0 3.792-1.72 5.056 5.056 0 0 0 3.79 1.72 5.032 5.032 0 0 0 3.792-1.72 5.056 5.056 0 0 0 3.791 1.72 5.032 5.032 0 0 0 3.791-1.72 5.056 5.056 0 0 0 3.792 1.72 5.032 5.032 0 0 0 3.79-1.72 5.113 5.113 0 0 0 2.528 1.576v28.134h-2.527Zm6.319-33.04c0 .674-.267 1.32-.74 1.797a2.52 2.52 0 0 1-3.575 0 2.548 2.548 0 0 1-.74-1.797v-2.542h5.055v2.542Zm-20.22 7.624H10.11a1.26 1.26 0 0 0-.894.372c-.237.239-.37.562-.37.899v17.79c0 .338.133.66.37.899.237.238.559.372.894.372h15.165c.335 0 .656-.134.893-.372s.37-.561.37-.898V29.268c0-.337-.133-.66-.37-.899a1.26 1.26 0 0 0-.893-.372Zm-1.264 17.79H11.374V30.54H24.01v15.249Zm-11.374-2.54v-5.084h2.528v3.813h3.791v2.541h-5.055a1.26 1.26 0 0 1-.893-.372 1.274 1.274 0 0 1-.37-.899Z" />
    </svg>
  );
};

export const VirtualIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      width="57"
      height="57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 57 57"
      {...props}
    >
      <path
        d="M53.824.652H3.78c-.737 0-1.444.294-1.966.819A2.804 2.804 0 0 0 1 3.448v38.207c0 .741.293 1.453.814 1.977a2.772 2.772 0 0 0 1.966.819h21.315v4.659a.935.935 0 0 1-.271.659.924.924 0 0 1-.655.273H11.194c-.737 0-1.444.294-1.966.819a2.804 2.804 0 0 0-.814 1.977v.931c0 .742.293 1.453.814 1.977a2.772 2.772 0 0 0 1.966.82H46.41c.738 0 1.445-.295 1.966-.82a2.804 2.804 0 0 0 .814-1.977v-.931c0-.742-.292-1.453-.814-1.977a2.772 2.772 0 0 0-1.966-.82H33.436a.924.924 0 0 1-.655-.272.935.935 0 0 1-.272-.659v-4.66h21.315c.738 0 1.445-.294 1.966-.818a2.803 2.803 0 0 0 .814-1.977V3.448c0-.742-.293-1.453-.814-1.977a2.772 2.772 0 0 0-1.966-.82ZM22.315 2.516h12.974v3.727H22.315V2.516Zm-19.462.932c0-.248.098-.485.272-.66a.924.924 0 0 1 .655-.272h16.681v4.66c0 .246.098.483.272.658.174.175.41.273.655.273h6.487V19.29h-8.34v-4.287a3.173 3.173 0 0 0-.459-1.633 3.15 3.15 0 0 0-1.233-1.158 3.705 3.705 0 0 0-.32-4.877 3.697 3.697 0 0 0-5.243 0 3.738 3.738 0 0 0-1.086 2.636c.004.81.273 1.595.765 2.236a3.149 3.149 0 0 0-1.234 1.16 3.173 3.173 0 0 0-.458 1.636v4.287H2.853V3.448Zm10.565 10.25h2.966c.344 0 .674.138.917.382.244.245.38.577.38.923v4.287h-5.56v-4.287c0-.346.137-.678.38-.923.243-.244.573-.382.917-.382Zm-.37-3.727a1.87 1.87 0 0 1 1.144-1.722 1.844 1.844 0 0 1 2.02.404 1.868 1.868 0 0 1-1.31 3.181c-.492 0-.964-.196-1.311-.545a1.869 1.869 0 0 1-.543-1.318ZM2.853 21.153h25.022v15.843h-8.34v-4.287a3.172 3.172 0 0 0-.459-1.633 3.148 3.148 0 0 0-1.233-1.158 3.705 3.705 0 0 0-.32-4.877 3.697 3.697 0 0 0-2.622-1.092c-.983 0-1.926.393-2.621 1.092a3.704 3.704 0 0 0-.321 4.877 3.148 3.148 0 0 0-1.233 1.158 3.171 3.171 0 0 0-.459 1.633v4.286H2.853V21.154Zm10.565 10.251h2.966c.344 0 .674.138.917.382.244.245.38.577.38.923v4.286h-5.56V32.71c0-.346.137-.678.38-.923.243-.244.573-.382.917-.382Zm-.37-3.727a1.871 1.871 0 0 1 1.144-1.722 1.844 1.844 0 0 1 2.02.404 1.868 1.868 0 0 1-.281 2.867 1.846 1.846 0 0 1-2.34-.232 1.869 1.869 0 0 1-.543-1.317Zm20.388 24.229H46.41c.246 0 .482.098.656.273a.935.935 0 0 1 .271.659v.931a.935.935 0 0 1-.272.66.924.924 0 0 1-.655.272H11.194a.924.924 0 0 1-.655-.273.935.935 0 0 1-.272-.658v-.932c0-.248.098-.485.272-.66a.924.924 0 0 1 .655-.272H24.17c.737 0 1.444-.295 1.965-.82a2.803 2.803 0 0 0 .815-1.976v-4.66h3.707v4.66c0 .742.293 1.453.814 1.977a2.772 2.772 0 0 0 1.966.819ZM54.75 41.655a.935.935 0 0 1-.272.659.924.924 0 0 1-.655.273H3.78a.924.924 0 0 1-.655-.273.935.935 0 0 1-.272-.66V38.86h51.898v2.796Zm-13.53-10.25h2.965c.344 0 .674.137.917.381.244.245.38.577.38.923v4.286h-5.56V32.71c0-.346.137-.678.38-.923.243-.244.573-.382.918-.382Zm-.371-3.728a1.871 1.871 0 0 1 1.144-1.722 1.844 1.844 0 0 1 2.02.404 1.867 1.867 0 0 1 .402 2.03c-.14.341-.378.633-.683.837a1.846 1.846 0 0 1-2.34-.232 1.869 1.869 0 0 1-.543-1.317Zm13.9 9.319h-7.413v-4.287a3.172 3.172 0 0 0-.459-1.633 3.148 3.148 0 0 0-1.232-1.158 3.705 3.705 0 0 0-.322-4.877 3.697 3.697 0 0 0-5.242 0 3.704 3.704 0 0 0-.321 4.877 3.148 3.148 0 0 0-1.233 1.158 3.171 3.171 0 0 0-.458 1.633v4.286h-8.341V21.154H54.75v15.843ZM41.22 13.698h2.966c.344 0 .674.138.917.382.244.245.38.577.38.923v4.287h-5.56v-4.287c0-.346.137-.678.38-.923.243-.244.573-.382.918-.382Zm-.37-3.727a1.87 1.87 0 0 1 1.144-1.722 1.844 1.844 0 0 1 2.02.404 1.867 1.867 0 0 1 .402 2.031c-.14.34-.378.632-.683.836a1.846 1.846 0 0 1-2.34-.231 1.869 1.869 0 0 1-.543-1.318Zm13.9 9.319h-7.413v-4.287a3.173 3.173 0 0 0-.459-1.633 3.15 3.15 0 0 0-1.232-1.158 3.705 3.705 0 0 0-.322-4.877 3.697 3.697 0 0 0-5.242 0 3.738 3.738 0 0 0-1.086 2.636c.004.81.273 1.595.765 2.236a3.148 3.148 0 0 0-1.234 1.16 3.172 3.172 0 0 0-.457 1.636v4.287h-8.341V8.107h6.487a.924.924 0 0 0 .655-.273.934.934 0 0 0 .272-.659v-4.66h16.681a.935.935 0 0 1 .927.932V19.29Z"
        strokeWidth=".5"
      />
    </svg>
  );
};

export const DiscussionIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      width="56"
      height="57"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 56 57"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.604 28.776c0 13.698-11.104 24.802-24.802 24.802S3 42.474 3 28.776 14.104 3.974 27.802 3.974s24.802 11.104 24.802 24.802Zm3 0c0 15.355-12.447 27.802-27.802 27.802C12.448 56.578 0 44.131 0 28.776S12.447.974 27.802.974 55.604 13.42 55.604 28.776Zm-39.031.357a1.691 1.691 0 1 1-3.383 0 1.691 1.691 0 0 1 3.383 0Zm2.4 0a4.092 4.092 0 1 1-8.183 0 4.092 4.092 0 0 1 8.183 0Zm10.556 0a1.691 1.691 0 1 1-3.383 0 1.691 1.691 0 0 1 3.383 0Zm2.4 0a4.092 4.092 0 1 1-8.184 0 4.092 4.092 0 0 1 8.184 0Zm8.865 1.692a1.691 1.691 0 1 0 0-3.383 1.691 1.691 0 0 0 0 3.383Zm0 2.4a4.092 4.092 0 1 0 0-8.184 4.092 4.092 0 0 0 0 8.183Z"
      />
    </svg>
  );
};

export const ClockIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 1C9.73261 1 1 9.73261 1 20.5C1 31.2674 9.73261 40 20.5 40C31.2674 40 40 31.2674 40 20.5C40 9.73261 31.2674 1 20.5 1ZM20.5 2.69565C30.3348 2.69565 38.3043 10.6652 38.3043 20.5C38.3043 30.3348 30.3348 38.3043 20.5 38.3043C10.6652 38.3043 2.69565 30.3348 2.69565 20.5C2.69565 10.6652 10.6652 2.69565 20.5 2.69565Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.23857 21.3475H8.62988C9.13857 21.3475 9.4777 21.0084 9.4777 20.4997C9.4777 19.991 9.13857 19.6519 8.62988 19.6519H5.23857C4.72988 19.6519 4.39075 19.991 4.39075 20.4997C4.39075 21.0084 4.72988 21.3475 5.23857 21.3475Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70829 28.8634L10.6452 27.1678C11.0858 26.9134 11.2099 26.4502 10.9556 26.0096C10.7012 25.5691 10.238 25.4449 9.79741 25.6993L6.86046 27.3949C6.41992 27.6493 6.29579 28.1125 6.55013 28.5531C6.80448 28.9936 7.26774 29.1178 7.70829 28.8634Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6033 34.14L15.299 31.203C15.5533 30.7625 15.4292 30.2992 14.9887 30.0448C14.5481 29.7905 14.0849 29.9146 13.8305 30.3552L12.1349 33.2921C11.8805 33.7327 12.0046 34.1959 12.4452 34.4503C12.8857 34.7046 13.349 34.5805 13.6033 34.14Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3475 35.7615V32.3702C21.3475 31.8615 21.0084 31.5224 20.4997 31.5224C19.991 31.5224 19.6519 31.8615 19.6519 32.3702V35.7615C19.6519 36.2702 19.991 36.6094 20.4997 36.6094C21.0084 36.6094 21.3475 36.2702 21.3475 35.7615Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8648 33.2917L27.1691 30.3548C26.9148 29.9142 26.4515 29.7901 26.011 30.0444C25.5704 30.2988 25.4463 30.762 25.7006 31.2026L27.3963 34.1395C27.6506 34.5801 28.1139 34.7042 28.5544 34.4499C28.995 34.1955 29.1191 33.7323 28.8648 33.2917Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.14 27.3967L31.203 25.701C30.7625 25.4467 30.2992 25.5708 30.0448 26.0113C29.7905 26.4519 29.9146 26.9151 30.3552 27.1695L33.2921 28.8651C33.7327 29.1195 34.1959 28.9954 34.4503 28.5548C34.7046 28.1143 34.5805 27.651 34.14 27.3967Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.7606 19.6519H32.3693C31.8606 19.6519 31.5215 19.991 31.5215 20.4997C31.5215 21.0084 31.8606 21.3475 32.3693 21.3475H35.7606C36.2693 21.3475 36.6084 21.0084 36.6084 20.4997C36.6084 19.991 36.2693 19.6519 35.7606 19.6519Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.2928 12.1351L30.3558 13.8307C29.9153 14.0851 29.7911 14.5483 30.0455 14.9889C30.2998 15.4294 30.7631 15.5536 31.2036 15.2992L34.1406 13.6036C34.5811 13.3492 34.7053 12.8859 34.4509 12.4454C34.1966 12.0049 33.7333 11.8807 33.2928 12.1351Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.3957 6.85981L25.7 9.79677C25.4457 10.2373 25.5698 10.7006 26.0104 10.9549C26.4509 11.2093 26.9142 11.0851 27.1685 10.6446L28.8642 7.70764C29.1185 7.2671 28.9944 6.80384 28.5538 6.54949C28.1133 6.29514 27.65 6.41927 27.3957 6.85981Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6519 5.23939V8.63069C19.6519 9.13939 19.991 9.47852 20.4997 9.47852C21.0084 9.47852 21.3475 9.13939 21.3475 8.63069V5.23939C21.3475 4.73069 21.0084 4.39156 20.4997 4.39156C19.991 4.39156 19.6519 4.73069 19.6519 5.23939Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1343 7.70723L13.83 10.6442C14.0843 11.0847 14.5476 11.2089 14.9881 10.9545C15.4287 10.7002 15.5528 10.2369 15.2985 9.79635L13.6028 6.8594C13.3485 6.41886 12.8852 6.29473 12.4447 6.54907C12.0041 6.80342 11.88 7.26668 12.1343 7.70723Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.86055 13.6043L9.7975 15.3C10.238 15.5543 10.7013 15.4302 10.9557 14.9896C11.21 14.5491 11.0859 14.0858 10.6453 13.8315L7.70837 12.1358C7.26783 11.8815 6.80457 12.0056 6.55022 12.4462C6.29587 12.8867 6.42 13.35 6.86055 13.6043Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6519 12.0219V20.5002C19.6519 20.7545 19.7366 20.9241 19.9062 21.0936L25.841 27.0284C26.1801 27.3676 26.6888 27.3676 27.0279 27.0284C27.3671 26.6893 27.3671 26.1806 27.0279 25.8415L21.3475 20.161V12.0219C21.3475 11.5132 21.0084 11.1741 20.4997 11.1741C19.991 11.1741 19.6519 11.5132 19.6519 12.0219Z"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export const CalendarIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      width="42"
      height="39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 42 39"
      {...props}
    >
      <path d="M40.217 39H.98a.98.98 0 0 1-.98-.981v-26.15a.981.981 0 0 1 .98-.982h39.236a.98.98 0 0 1 .98.981V38.02a.98.98 0 0 1-.98.98ZM1.962 37.038h37.274V12.85H1.962v24.19Z" />
      <path d="M40.217 12.85H.98a.981.981 0 0 1-.98-.981v-4.14a3.374 3.374 0 0 1 3.373-3.374h34.45a3.374 3.374 0 0 1 3.374 3.374v4.14a.98.98 0 0 1-.981.98ZM1.962 10.888h37.274V7.729a1.412 1.412 0 0 0-1.413-1.412H3.374a1.412 1.412 0 0 0-1.412 1.412v3.159Z" />
      <path d="M14.302 9.691a1 1 0 0 1-.981-.98V.98a.98.98 0 1 1 1.962 0v7.631a.982.982 0 0 1-.981 1.08ZM7.514 9.691a.98.98 0 0 1-.98-.98V.98a.98.98 0 1 1 1.96 0v7.631a1 1 0 0 1-.98 1.08ZM33.448 9.691a.981.981 0 0 1-.98-.98V.98a.981.981 0 0 1 1.961 0v7.631a1 1 0 0 1-.98 1.08ZM26.641 9.691a1 1 0 0 1-.98-.98V.98a.981.981 0 0 1 1.961 0v7.631a.98.98 0 0 1-.98 1.08ZM20.6 9.691a.98.98 0 0 1-.982-.98V.98a.98.98 0 1 1 1.962 0v7.631a1.001 1.001 0 0 1-.98 1.08ZM13.694 22.345H8.279a.98.98 0 0 1-.98-.981v-5.395a1 1 0 0 1 .98-.981h5.415a1 1 0 0 1 .98.98v5.494a.981.981 0 0 1-.98.883ZM9.26 20.383h3.492V16.95H9.26v3.433ZM32.742 22.345h-5.394a.98.98 0 0 1-.981-.981v-5.395a.98.98 0 0 1 .98-.981h5.395a1 1 0 0 1 .981.98v5.494a.98.98 0 0 1-.98.883Zm-4.414-1.962h3.434V16.95h-3.434v3.433ZM23.208 22.345h-5.395a.98.98 0 0 1-.98-.981v-5.395a.98.98 0 0 1 .98-.981h5.395a.98.98 0 0 1 .981.98v5.494a.981.981 0 0 1-.98.883Zm-4.414-1.962h3.433V16.95h-3.433v3.433ZM23.365 34.92H17.97a.98.98 0 0 1-.98-.981v-5.395a.98.98 0 0 1 .98-.981h5.395a.98.98 0 0 1 .981.98v5.396a.981.981 0 0 1-.98.98Zm-4.414-1.962h3.433v-3.433h-3.433v3.433ZM13.85 34.92H8.436a1 1 0 0 1-.981-.981v-5.395a.98.98 0 0 1 .98-.981h5.415a.98.98 0 0 1 .981.98v5.396a1 1 0 0 1-.98.98Zm-4.434-1.962h3.453v-3.433H9.416v3.433ZM32.9 34.92h-5.395a.98.98 0 0 1-.981-.981v-5.395a.98.98 0 0 1 .98-.981H32.9a.98.98 0 0 1 .98.98v5.396a.98.98 0 0 1-.98.98Zm-4.415-1.962h3.434v-3.433h-3.473l.04 3.433Z" />
    </svg>
  );
};

export const CloseIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      width="12"
      height="12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m1 1 10 10M11 1 1 11" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export const CheckIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx={12} cy={12} r={12} />
      <path
        d="M7 13l3 3 7-7"
        stroke="#fff"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CircleIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx={12} cy={12} r={11} strokeWidth={2} />
    </svg>
  );
};

export const ChevronDownIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M12 15.5a1 1 0 0 1-.71-.29l-4-4a1 1 0 1 1 1.42-1.42L12 13.1l3.3-3.18a1 1 0 1 1 1.38 1.44l-4 3.86a1 1 0 0 1-.68.28z"></path>
      </g>
    </svg>
  );
};

export const ChevronLeftIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8.381 16.205"
      focusable="false"
      role="img"
      fill="currentColor"
      strokeWidth="1.5"
      {...props}
    >
      <path d="M7.65 15.714 1.002 8.047 7.824.503" fill="none" />
    </svg>
  );
};

export const ChevronRightIcon = (
  props: ComponentProps<'svg'>,
): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8.381 16.205"
      focusable="false"
      role="img"
      fill="currentColor"
      strokeWidth="1.5"
      {...props}
    >
      <path d="m.731.491 6.648 7.667-6.822 7.544" fill="none" />
    </svg>
  );
};

export const ChevronUpIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"></path>
    </svg>
  );
};

export const ArrowRightCircleIcon = (
  props: ComponentProps<'svg'>,
): ReactElement => {
  return (
    <svg
      viewBox="0 0 16 16"
      focusable="false"
      role="img"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"></path>
    </svg>
  );
};

export const ArrowRight = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      width="19.896"
      height="12.799"
      focusable="false"
      role="img"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1.5"
      {...props}
    >
      <g fill="none">
        <path d="M18.285 6.41H0" />
        <path d="m12.816.535 6 5.906-6.156 5.813" />
      </g>
    </svg>
  );
};

export const PlayIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      focusable="false"
      role="img"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      width="31.533"
      height="34.382"
      {...props}
    >
      <path
        data-name="Polygon 2"
        d="M28.996 14.572a3 3 0 0 1 0 5.238L5.463 32.96A3 3 0 0 1 1 30.341V4.04a3 3 0 0 1 4.463-2.619Z"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
      />
    </svg>
  );
};

export const CheckCircleIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28.54 28.54"
      focusable="false"
      role="img"
      fill="currentColor"
      {...props}
    >
      <path d="M14.27 28.54A14.286 14.286 0 0 1 0 14.27 14.287 14.287 0 0 1 14.27 0a14.286 14.286 0 0 1 14.27 14.27 14.286 14.286 0 0 1-14.27 14.27Zm0-27.178A12.922 12.922 0 0 0 1.363 14.269 12.922 12.922 0 0 0 14.27 27.177 12.922 12.922 0 0 0 27.177 14.27 12.922 12.922 0 0 0 14.27 1.363Z" />
      <path d="m11.502 21.312-5.921-5.921 2.13-2.13 3.791 3.79 9.574-9.574 2.13 2.13Z" />
    </svg>
  );
};

export const TelephoneIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      viewBox="0 0 100 100"
      focusable="false"
      role="img"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M84.96 70.237c-.167-1.032-.814-1.914-1.783-2.438l-14.335-8.446-.118-.066a4.256 4.256 0 0 0-1.937-.45c-1.201 0-2.348.455-3.144 1.253l-4.231 4.233c-.181.172-.771.421-.95.43-.049-.004-4.923-.355-13.896-9.329-8.957-8.955-9.337-13.844-9.34-13.844.005-.25.251-.838.426-1.02l3.608-3.607c1.271-1.274 1.652-3.386.898-5.022L32.19 16.938c-.579-1.192-1.704-1.928-2.952-1.928-.883 0-1.735.366-2.401 1.031l-9.835 9.813c-.943.938-1.755 2.578-1.932 3.898-.086.631-1.831 15.693 18.819 36.346C51.42 83.627 65.09 84.989 68.865 84.989a10.7 10.7 0 0 0 1.376-.071c1.316-.176 2.954-.986 3.891-1.925l9.827-9.826c.802-.806 1.168-1.871 1.001-2.93z"></path>
    </svg>
  );
};

export const MailIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      viewBox="0 0 48 48"
      focusable="false"
      role="img"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M43 16.98v16.77c0 2.9-2.35 5.25-5.25 5.25h-27.5A5.25 5.25 0 0 1 5 33.75V16.98L23.4 27.1c.37.2.83.2 1.2 0L43 16.98zM37.75 9A5.25 5.25 0 0 1 43 14.12L24 24.57 5 14.12v-.09A5.25 5.25 0 0 1 10.25 9h27.5z"></path>
    </svg>
  );
};

export const SpinnerIcon = ({
  className,
  ...props
}: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      role="status"
      className={cx('animate-spin text-[white]', className)}
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="#E5E7EB"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const QuestionMarkBadgeIcon = (
  props: ComponentProps<'svg'>,
): ReactElement => {
  return (
    <svg
      viewBox="0 0 16 16"
      focusable="false"
      role="img"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8.05 9.6c.336 0 .504-.24.554-.627.04-.534.198-.815.847-1.26.673-.475 1.049-1.09 1.049-1.986 0-1.325-.92-2.227-2.262-2.227-1.02 0-1.792.492-2.1 1.29A1.71 1.71 0 0 0 6 5.48c0 .393.203.64.545.64.272 0 .455-.147.564-.51.158-.592.525-.915 1.074-.915.61 0 1.03.446 1.03 1.084 0 .563-.208.885-.822 1.325-.619.433-.926.914-.926 1.64v.111c0 .428.208.745.585.745z"></path>
      <path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"></path>
      <path d="M7.001 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0z"></path>
    </svg>
  );
};

export const InfoCircleIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      viewBox="0 0 16 16"
      focusable="false"
      role="img"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
      <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
    </svg>
  );
};

export const PlusIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 15"
      focusable="false"
      role="img"
      {...props}
    >
      <path fill="none" d="M15 7.445H0" />
      <path fill="none" d="M7.5 0v15" />
    </svg>
  );
};

export const MinusIcon = (props: ComponentProps<'svg'>): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 1"
      focusable="false"
      role="img"
      {...props}
    >
      <path fill="none" d="M15 .5H0" />
    </svg>
  );
};
